export default __webpack_public_path__ + "static/modal-dont-light-74e53ce92ea73f602fc1cbf950f0bafa.png";